<script>
	import BarraCaracteristicas from './../components/BarraCaracteristicas.svelte';
	import Selos from './../components/Selos.svelte';

	import { Router, Link, link, Route } from "svelte-routing";
	import { beforeUpdate, afterUpdate } from 'svelte';

	export let realty       = {Description:''};
	export let loading      = false;
	export let hideItems    = ["LotArea","Furnished","SemiFurnished"];
	export let type			= 'card';
	export let index		= 0;
	let showVideo = false;

	let description = realty.Description.length > 100 ? realty.Description.substring(0, 100) : realty.Description;

	function replaceAll(str, de, para){
		if (typeof(str) == 'undefined') {
			return '';
		}
		
		let pos = str.indexOf(de);
		while (pos > -1){
			str = str.replace(de, para);
			pos = str.indexOf(de);
		}
		return str;
	}
	function getDetailURL() {
		let url = '/imovel/' + realty.CurrentNegotiationTypeTitle + '/' + realty.Id + '/imovel-';

		url = url + replaceAll(realty.CurrentRealtyTypeTitle, '/', '-');
		if (realty.CurrentSpot != null) {
			if (realty.CurrentSpot.Neighborhood != null && realty.CurrentSpot.Neighborhood != '') {
				url	= url + '-em-' + realty.CurrentSpot.Neighborhood;
			}

			if (realty.CurrentSpot.City != null && realty.CurrentSpot.City != '') {
				url	= url + '-' + realty.CurrentSpot.City;
			}
		}

		if (realty.MLSID != null && realty.MLSID != '') {
			url	= url + '-Cod-' + realty.MLSID;
		}

		return url.replaceAll(' ', '-');
	}

	let url = getDetailURL();

	//Carrega bookmarks
	atria.loadBookmarks();
	
	let favoritar = { 
		favorito: atria.hasBookmark(realty.CurrentNegotiationTypeId, realty.Id) 
	};

	function toggleBookmarks() {
		if (atria.hasBookmark(realty.CurrentNegotiationTypeId, realty.Id)) {
			atria.removeBookmark(realty.CurrentNegotiationTypeId, realty.Id);
		} else {
			atria.addBookmark(realty.CurrentNegotiationTypeId, realty.Id);
		}

		favoritar.favorito = !favoritar.favorito;
	}

	function videoClick() {
		console.log('index: ',index);
		jQuery('.section-video .hero .items').slick('slickGoTo', index);
		scrollTo('.section-video');
	}

	async function loadPhotos() 
	{
		loadingPhotos = true;
		let url = `${atria.mainURL}/Services/RealEstate/JSONP/List.aspx?mode=realty&callback=null&`;
		url += Object.entries({nt:realty.CurrentNegotiationTypeId, ri:realty.Id}).map(e=>`${e[0]}=${e[1]}`).join('&');
		let response = await fetch(url,{
			method: 'GET',
			mode: 'cors'
		});
		let data = await response.json()

		if (!data.Error && data.Items.length == 1) {
			images = [... data.Items[0].Photos];
			hasLoadPhotos = true;
		}

		loadingPhotos = true;
	}
	async function nextPhoto() {
		jQuery(`.card--realty-${realty.Id} .carousel .carousel-inner`).slick('next');
	}
	async function prevPhoto() {
		jQuery(`.card--realty-${realty.Id} .carousel .carousel-inner`).slick('prev');
	}
	function fixPhotoPath(path) {
		if (!path.startsWith('http://') && !path.startsWith('https://')) {
			return `${atria.mainURL}${path}`;
		}

		return path;
	}

	$: hasLoadPhotos = false;
	$: loadingPhotos = false;
	$: images = realty.Image != null && realty.Image.length > 0 ? [{Title:realty.Title,Path:fixPhotoPath(realty.Image)}] : [];

	afterUpdate(() => {
		if (jQuery(`.card--realty-${realty.Id} .carousel .carousel-inner`).length > 0) {

			jQuery(`.card--realty-${realty.Id} .carousel .carousel-inner`).slick({
				infinite: true,
				speed: 400,
				slidesToShow: 1,
				autoplay: true,
				arrows: false,
				dots: false
			});
			jQuery(`.card--realty-${realty.Id} .carousel .carousel-inner`).slick('next');
		}
	});

	//loadPhotos();
</script>

{#if loading}
	<div class="card loading">
		<div class="card-image">
			<figure class="image">
				<span class="loading-img" style="height: 200px;"></span>
			</figure>
		</div>
		<div class="card-content">
			<p class="title is-4"><span class="loading-text" style="max-width:150px;height:35px;"></span></p>
			<p class="subtitle is-6"><span class="loading-text" style="height:28px;"></span></p>
			<div class="content"><span class="loading-text" style="height:28px;"></span></div>
		</div>
	</div>
{:else}
	{#if type === 'card'}
	<div class="card card--{realty.CurrentNegotiationTypeTitle} card--realty-{realty.Id}">
		<div class="card-image">
			{#if loadingPhotos}
			<div class="loading" class:hide={hasLoadPhotos}>
				<i class="fal fa-spinner-third fa-spin"></i>
			</div>
			{/if}
			<a href="{url}" target="_blank">
				{#if images.length <= 1}
				<figure class="image loading-img">
					<img loading="lazy" onerror="ImageNotFound(this);" src="{fixPhotoPath(realty.Image)}" alt="{realty.Title}">
				</figure>
				<button class:hide={hasLoadPhotos} onclick="return false;" on:click={loadPhotos} type="button" class="slick-next slick-arrow" aria-label="Ver fotos">Ver fotos</button>
				{:else}
				<div class="carousel slide" data-interval="false" data-wrap="false">
					<div class="carousel-inner" role="listbox">
						{#each images as image, i}
						<div class="item">
							<figure class="image loading-img">
								<img loading="lazy" onerror="ImageNotFound(this);" src="{fixPhotoPath(image.Path)}" alt="{image.Title}">
							</figure>
						</div>
						{/each}
					</div>
				</div>
				<button onclick="return false;" on:click={nextPhoto} type="button" class="slick-next slick-arrow" aria-label="Próxima">Próxima</button>
				<button onclick="return false;" on:click={prevPhoto} type="button" class="slick-prev slick-arrow" aria-label="Anterior">Anterior</button>
				{/if}
				<div class="favoritar">
					{#if favoritar.favorito}
						<a href="javascript:void(0)" class="favorito icon-transform" onclick="return false;" on:click={toggleBookmarks}><i class="fas fa-heart"></i></a>
					{:else }
						<a href="javascript:void(0)" class="favorito icon-transform" onclick="return false;" on:click={toggleBookmarks}><i class="far fa-heart"></i></a>
					{/if}                    
				</div>
				{#if realty.DiscountPrice > 0}
				<div class="discount" title="Desconto">
					<i class="fal fa-long-arrow-down"></i> {realty.DiscountPricePercent}%
				</div>
				{/if}
				<div class="price">
					{#if realty.ShowPrice}
						{#if realty.DiscountPrice > 0}
						<span class="oldprice">
							<span class="text-nowrap">De R$ {realty.FormattedDiscountPrice}</span>
						</span>
						{/if}
						<p class="btn text-nowrap">Por R$ {realty.FormattedPrice}</p>
					{:else}
						<p class="btn">Consulte</p>
					{/if}
				</div>
				<div class="negotiationtype">
					{#if realty.CurrentNegotiationTypeId == atria.rent}
					Aluguel
					{:else}
					Comprar
					{/if}
				</div>
				<Selos realty={realty} loading={loading} />
			</a>
		</div>
		<div class="card-content">
			<h3 class="item">
				<b>{realty.CurrentRealtyTypeTitle}</b>
			</h3>
			<div class="item">
				<address>
					{#if realty.CurrentSpot.CurrentAddress != null && realty.CurrentSpot.CurrentAddress.length > 0}
					<p><small>{atria.toTitleCase(realty.CurrentSpot.CurrentAddress)}</small></p>
					{/if}
					{#if realty.CurrentSpot.Neighborhood != null && realty.CurrentSpot.Neighborhood.length > 0}
					<p>{atria.toTitleCase(realty.CurrentSpot.Neighborhood)}, {atria.toTitleCase(realty.CurrentSpot.City)}</p>
					{:else}
					<p>{atria.toTitleCase(realty.CurrentSpot.City)}</p>
					{/if}
				</address>
			</div>
			<div class="item mt-20">
				<BarraCaracteristicas style="list" realty={realty} hideItems={hideItems} />
			</div>
		</div>
	</div>
	{:else if type === 'video'}
	<div class="card video-card card--{realty.CurrentNegotiationTypeTitle} card--realty-{realty.Id}" on:click={videoClick}>
		<div class="card-image">
			<figure class="image loading-img">
				<img loading="lazy" onerror="ImageNotFound(this);" src="{fixPhotoPath(realty.Image)}" alt="{realty.Title}">
			</figure>
			<span class="play-button"><i class="far fa-play-circle"></i></span>
		</div>
		<div class="card-content">
			<h3 class="item">
				<b>{realty.CurrentRealtyTypeTitle}</b>
			</h3>
			<div class="item">
				<address>
					{#if realty.CurrentSpot.CurrentAddress != null && realty.CurrentSpot.CurrentAddress.length > 0}
					<p><small>{atria.toTitleCase(realty.CurrentSpot.CurrentAddress)}</small></p>
					{/if}
					{#if realty.CurrentSpot.Neighborhood != null && realty.CurrentSpot.Neighborhood.length > 0}
					<p>{atria.toTitleCase(realty.CurrentSpot.Neighborhood)}, {atria.toTitleCase(realty.CurrentSpot.City)}</p>
					{:else}
					<p>{atria.toTitleCase(realty.CurrentSpot.City)}</p>
					{/if}
				</address>
			</div>
		</div>
	</div>
	{:else if type === 'video-hero'}
	<div class="card videohero-card card--{realty.CurrentNegotiationTypeTitle} card--realty-{realty.Id}">
		<div class="card-image">
			{#if !showVideo}
			<a on:click={()=>{showVideo=true;}}>
				<figure class="image loading-img">
					<img loading="lazy" onerror="ImageNotFound(this);" src="{fixPhotoPath(realty.Image)}" alt="{realty.Title}">
				</figure>
				<span class="play-button"><i class="far fa-play-circle"></i></span>
			</a>
			{:else}
			<iframe src="https://www.youtube.com/embed/{realty.Video}?controls=1&rel=0&autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
			{/if}
		</div>
		<div class="card-content">
			<h3>
				<b>{realty.CurrentRealtyTypeTitle}</b>
			</h3>
			<address>
				{#if realty.CurrentSpot.CurrentAddress != null && realty.CurrentSpot.CurrentAddress.length > 0}
				<p><small>{atria.toTitleCase(realty.CurrentSpot.CurrentAddress)}</small></p>
				{/if}
				{#if realty.CurrentSpot.Neighborhood != null && realty.CurrentSpot.Neighborhood.length > 0}
				<p>{atria.toTitleCase(realty.CurrentSpot.Neighborhood)}, {atria.toTitleCase(realty.CurrentSpot.City)}</p>
				{:else}
				<p>{atria.toTitleCase(realty.CurrentSpot.City)}</p>
				{/if}
			</address>
			<p>{@html realty.Description}</p>
			<a class="btn btn-primary" href="{url}" target="_blank">Saiba mais</a>
		</div>
	</div>
	{/if}
{/if}

<style type="text/sass">
@import 'public/assets/sass/variables.sass'
.card.loading
	.card-image
		.img
			width: 100%
			height: 200px
			background-color: #999
.card-image
	.loading
		position: absolute
		font-size: 48px
		z-index: 1
		background-color: rgba(0,0,0,0.65)
		width: 100%
		height: 100%
		display: flex
		justify-content: center
		align-items: center
		color: #FFF
		&.hide
			display: none
.card .slick-next
	right: 10px
.card .slick-prev
	left: 10px
// Paginação 
.page-item.active .page-link
	background-color: $color-secondary
	border-color: $color-secondary    

</style>